import {
  Box,
  Grid,
  createTheme,
  ThemeProvider,
  Menu,
  Stack,
  Select,
  FormControl,
  DialogTitle,
  DialogActions,
  Card,
  CardContent,
} from "@mui/material";
import React, { useEffect, useState, useCallback } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import ListItemText from "@mui/material/ListItemText";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";

import MenuItem from "@mui/material/MenuItem";
import MUIDataTable from "mui-datatables";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";

import AddIcon from "@mui/icons-material/Add";

import MoreHorizTwoToneIcon from "@mui/icons-material/MoreHorizTwoTone";

import StatusAlert from "../../../StatusAlertList/StatusAlert";

import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import EditNoteIcon from "@mui/icons-material/EditNote";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

import { useNavigate } from "react-router-dom";
import EmployeeHeader from "./EmployeeHeader";
import { useSelector } from "react-redux";
import {
  // departmentHRApi,
  // designationHRApi,
  employeeHRApis,
  LeadAgentsSettingsApi,
  departmentHRApi, // Add import for departmentHRApi
  designationHRApi, // Add import for designationHRApi
} from "../../../Data/axios";
import config from "../../../Data/AuthUser";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Employee() {
  const userPermissions = useSelector((state) => state?.user?.permissions);
  const [empid, setEmpid] = React.useState(false);
  const [name, setName] = React.useState(false);
  const [email, setEmail] = React.useState(false);
  const [password, setPassword] = React.useState(false);
  const [uploadFile, setUploadFile] = useState(null);
  const [designation, setDesignation] = React.useState(false);
  // const [department, setDepartment] = React.useState(false);
  const [mobile, setMobile] = React.useState(false);
  const [country, setCountry] = React.useState(false);

  const [reportingTo, setReportingTo] = React.useState(false);

  const [language, setLanguage] = React.useState(false);
  const [userRole, setUserRole] = React.useState(false);
  const [address, setAddress] = React.useState(false);
  const [about, setAbout] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");
  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [designations, setDesignations] = useState([]);
  const [selectedDesignation, setSelectedDesignation] = useState("");
  const [apiEmployees, setApiEmployees] = useState([]); // Added state for API employees
  const [loadingEmployees, setLoadingEmployees] = useState(false); // Added loading state

  // Pagination state variables
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(5);
  const [totalCount, setTotalCount] = useState(0);

  const showAlert = (message, severity) => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };
  const handleFileChangeProfile = (event) => {
    setUploadFile(event.target.files[0]);
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    // setFileName(file.name); // Update file name
    // Print file name to console
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // Event handler to update the date state and log the date to the console
  const handleDateChange = (newDate) => {
    // Log the new date to the console
  };

  const item = {
    empid,
    name,
    email,
    password,
    designation,
    reportingTo,
    mobile,
    country,
    language,
    userRole,
    address,
    about,
  };

  const navigate = useNavigate();
  const [employeeData, setEmployeeData] = useState([]);
  const [update, setUpdate] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState({
    keys: [],
    values: [],
    open: false,
  });

  const handleClickUpdate = () => {
    setUpdate(true);
  };

  const handleUpdateClose = () => {
    setUpdate(false);
  };
  const handleOpenMenu = (id) => {
    setOpenMenuId(id);
  };
  const handleViewMore = async (value) => {
    console.log("Fetching employee data for ID:", value);
    let response = await employeeHRApis.editById(value);
    response = response.data;
    navigate(`/hr/employees/${value}`, { state: response });
    // setOpenDialog(true);
  };

  // Function Starts Here

  const [updateMember, setUpdateMember] = React.useState("");
  const [updateLeaveType, setUpdateLeaveType] = React.useState("");

  const [updateDuration, setUpdateDuration] = React.useState("");
  const [updateDate, setUpdateDate] = useState(null); // Initialize state for the date
  const [updateMemberError, setUpdateMemberError] = React.useState(false);
  const [updateReason, setUpdateReason] = useState("");
  const [updateFileName, setUpdateFileName] = useState("");
  const [updateStatus, setUpdateStatus] = useState("");
  const [data, SetData] = useState([]);

  const [openMenuId, setOpenMenuId] = useState(null);

  async function SaveDate() {
    let result = await fetch(
      "https://rptpl.roadpilot.co.in/public/api/register",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(item),
      }
    );

    result = await result.json();

    showAlert(" Added successfully", "success");

    getData();
    setOpen(false);
  }

  // ends Here

  // Table Starts Here

  // Add useEffect to fetch departments and designations when the component mounts or when modal opens
  useEffect(() => {
    fetchDepartments();
    fetchDesignations();
    if (open || update) {
      fetchEmployees();
    }
  }, [open, update]);

  // Function to fetch departments
  const fetchDepartments = async () => {
    try {
      const response = await departmentHRApi.getAll();
      if (response && response.data) {
        setDepartments(response.data);
      } else {
        console.error("No departments found or empty response");
        setDepartments([]);
      }
    } catch (error) {
      console.error("Error fetching departments:", error);
      showAlert("Failed to load departments", "error");
    }
  };

  // Function to fetch designations
  const fetchDesignations = async () => {
    try {
      const response = await designationHRApi.getAll();
      if (response && response.data) {
        setDesignations(response.data);
      } else {
        console.error("No designations found or empty response");
        setDesignations([]);
      }
    } catch (error) {
      console.error("Error fetching designations:", error);
      showAlert("Failed to load designations", "error");
    }
  };

  // Function to fetch employees
  const fetchEmployees = async () => {
    setLoadingEmployees(true);
    try {
      const response = await LeadAgentsSettingsApi.getEmployee();
      if (response) {
        setApiEmployees(
          Array.isArray(response)
            ? response
            : response.data && Array.isArray(response.data)
            ? response.data
            : []
        );
      } else {
        setApiEmployees([]);
      }
    } catch (error) {
      console.error("Error fetching employees:", error);
      showAlert("Failed to load employees", "error");
    } finally {
      setLoadingEmployees(false);
    }
  };

  // Table data fetching function
  const getData = useCallback(async () => {
    try {
      const params = {
        page: page + 1, // API typically expects 1-based page numbers
        limit: limit,
      };
      const response = await employeeHRApis.getAll(params);
      setEmployeeData(response.data);

      // Set total count if the API response includes it
      if (response.total || response.totalCount) {
        setTotalCount(response.total || response.totalCount);
      }
    } catch (error) {
      console.error("Error fetching employee data:", error);
      showAlert("Failed to load employee data", "error");
    }
  }, [page, limit]);

  // useEffect to trigger getData when page or limit changes
  useEffect(() => {
    getData();
  }, [getData]);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const openDropMenu = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const leaveStatus = (value) => {
    if (value === "0")
      return <span style={{ color: "gray", fontSize: "15px" }}>Inactive</span>;
    if (value === "1")
      return <span style={{ color: "green", fontSize: "15px" }}>Active</span>;
    if (value === "2")
      return <span style={{ color: "red", fontSize: "15px" }}>Block</span>;
    return "Unknown";
  };
  const columns = [
    {
      name: "empid",
      label: "Employee ID",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Employee ID
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {(value || " ").charAt(0).toUpperCase() + (value || " ").slice(1)}
            </div>
          );
        },
      },
    },
    {
      name: "empid",
      label: "Name",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Name
            </th>
          );
        },
        customBodyRender: (value, tableMeta) => {
          const fullRecord = employeeData.find((item) => item.empid === value);

          if (!fullRecord) {
            return <div>Loading...</div>;
          }

          const imageUrl = `${config.apiImageUrl}${fullRecord.image}`;

          return (
            <div
              key={value.id}
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <img
                src={imageUrl}
                alt="Agent"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  marginRight: "10px",
                }}
              />
              <div>
                <div style={{ fontWeight: "bold", color: "#333" }}>
                  {fullRecord.name || ""}
                </div>
                <div style={{ color: "gray" }}>{fullRecord.role || ""}</div>
              </div>
            </div>
          );
        },
      },
    },
    {
      name: "email",
      label: "Email",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Email
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {value || " "}
            </div>
          );
        },
      },
    },
    {
      name: "role",
      label: "User Role",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              User Role
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {value || " "}
            </div>
          );
        },
      },
    },
    // {
    //   name: "report_to",
    //   label: "Reporting To",
    //   options: {
    //     customHeadRender: ({ index }) => {
    //       return (
    //         <th
    //           key={index}
    //           style={{
    //             textAlign: "center",
    //             borderBottom: "1px solid #ddd",
    //           }}
    //         >
    //           Reporting To
    //         </th>
    //       );
    //     },
    //     customBodyRender: (value, index) => {
    //       return (
    //         <div
    //           key={index}
    //           style={{
    //             display: "flex",
    //             justifyContent: "center",
    //             alignItems: "center",
    //           }}
    //         >
    //           {value !== null ? value : ""}
    //         </div>
    //       );
    //     },
    //   },
    // },
    {
      name: "status",
      label: "Status",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Status
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {leaveStatus(value)}
            </div>
          );
        },
      },
    },
    {
      name: "empid",
      label: "Action",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "right",
                paddingRight: "35px",
                borderBottom: "1px solid #ddd",
              }}
            >
              Action
            </th>
          );
        },
        customBodyRender: (value, tableMeta) => (
          <>
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "flex-end", // Aligns content to the left
                alignItems: "center",
                // Add padding for starting point
              }}
            >
              <div style={{ paddingRight: "5px" }}>
                <Button
                  id="basic-button"
                  aria-controls={openDropMenu ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={openDropMenu ? "true" : undefined}
                  onClick={handleClick}
                >
                  <div onClick={() => handleOpenMenu(value)}>
                    <MoreHorizTwoToneIcon />
                  </div>
                </Button>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={openDropMenu}
                  onClose={handleCloseMenu}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  {userPermissions?.employees_view !== 0 && (
                    <MenuItem onClick={handleCloseMenu}>
                      <div
                        onClick={() => handleViewMore(value)}
                        style={{
                          display: "flex",
                          justifyContent: "space-center",
                          alignItems: "center",
                        }}
                      >
                        <RemoveRedEyeIcon /> View More
                      </div>
                    </MenuItem>
                  )}
                  {userPermissions?.employees_update !== 0 && (
                    <MenuItem onClick={handleCloseMenu}>
                      <div
                        onClick={() => handleEdit(value)}
                        style={{
                          display: "flex",
                          justifyContent: "space-center",
                          alignItems: "center",
                        }}
                      >
                        <EditNoteIcon /> Edit
                      </div>
                    </MenuItem>
                  )}
                  {userPermissions?.employees_delete !== 0 && (
                    <MenuItem onClick={handleCloseMenu}>
                      <div
                        onClick={() => handleDelete(value)}
                        style={{
                          display: "flex",
                          justifyContent: "space-center",
                          alignItems: "center",
                        }}
                      >
                        <DeleteForeverIcon /> Delete
                      </div>
                    </MenuItem>
                  )}
                </Menu>
              </div>
            </div>
          </>
        ),
      },
    },
  ];

  async function handleEdit(id) {
    let result = await employeeHRApis.editById(id);
    SetData(result);
    handleClickUpdate();
  }

  // Update Values Start

  useEffect(() => {
    setUpdateMember(data.member);
  }, [data.member]);

  useEffect(() => {
    setUpdateDate(data.date);
  }, [data.date]);

  useEffect(() => {
    setUpdateDuration(data.duration);
  }, [data.duration]);

  useEffect(() => {
    setUpdateMemberError(data.managerError);
  }, [data.managerError]);

  useEffect(() => {
    setUpdateFileName(data.fileName);
  }, [data.fileName]);

  useEffect(() => {
    setUpdateReason(data.reason);
  }, [data.reason]);

  useEffect(() => {
    setUpdateLeaveType(data.leaveType);
  }, [data.leaveType]);

  useEffect(() => {
    setUpdateStatus(data.status);
  }, [data.status]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDialogDesig, setOpenDialogDesig] = useState(false);
  const [newDepartment, setNewDepartment] = useState("");
  const [newParentDepartment, setNewParentDepartment] = useState("");
  const [newParentDesignation, setNewParentDesignation] = useState("");

  const [newDesignation, setNewDesignation] = useState("");
  // const fetchData = async () => {
  //   setLoading(true);
  //   try {
  //     const { data } = await departmentHRApi.getAll();

  //     setDepartments(data);
  //     setError(null);
  //   } catch (err) {
  //     setError("Failed to fetch data. Please try again later.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  // useEffect(() => {
  //   fetchData();
  // }, []);

  // const fetchDataDesignation = async () => {
  //   setLoading(true);
  //   try {
  //     const { data } = await designationHRApi.getAll();
  //     console.log(data, "data got");
  //     setDesignations(data);
  //     setError(null);
  //   } catch (err) {
  //     setError("Failed to fetch data. Please try again later.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  // useEffect(() => {
  //   fetchDataDesignation();
  // }, []);

  const handleAddClick = () => {
    setOpenDialog(true); // Open dialog when Add button is clicked
  };
  const handleAddClickDesig = () => {
    setOpenDialogDesig(true); // Open dialog when Add button is clicked
  };
  const handleDialogClose = () => {
    setOpenDialog(false);
    setNewDepartment("");
    setNewParentDepartment(""); // Reset input field
  };
  const handleDialogCloseDesig = () => {
    setOpenDialogDesig(false);
    setNewDesignation("");
    setNewParentDesignation("");
  };
  async function AddDepartment() {
    const creator_name = localStorage.getItem("empid");
    let result = await fetch(
      `https://rptpl.roadpilot.co.in/public/api/addDepartment?department=${newDepartment}&parent=${newParentDesignation}&creator_id=${creator_name}`,
      {
        method: "POST",
      }
    );

    result = await result.json();

    showAlert(" Added successfully", "success");

    // fetchData();
    handleDialogClose();
  }
  async function AddDesignation() {
    const creator_name = localStorage.getItem("empid");
    let result = await fetch(
      `https://rptpl.roadpilot.co.in/public/api/addDesignation?designation=${newDesignation}&parent=${newParentDesignation}&creator=${creator_name}`,
      {
        method: "POST",
      }
    );

    result = await result.json();

    showAlert(" Added successfully", "success");

    // fetchDataDesignation();
    handleDialogCloseDesig();
  }

  const Marketing = "Marketing";
  const Sales = "Sales";
  const HumanResources = "Human Resource";
  const Research = "Research";
  const Finance = "Finance";
  const PublicRelations = "Public Relations";

  async function UpdateData() {
    const formData = new FormData();

    formData.append("member", updateMember);
    formData.append("memberError", updateMemberError);
    formData.append("fileName", updateFileName);
    formData.append("date", updateDate);
    formData.append("reason", updateReason);
    formData.append("duration", updateDuration);
    formData.append("leaveType", updateLeaveType);
    formData.append("status", updateStatus);
    try {
      let response = await fetch(
        `https://rptpl.roadpilot.co.in/public/api/updateBusinessLocation/${data.id}`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error("Failed to update data");
      }

      showAlert("Leave updated successfully", "success");

      handleUpdateClose();
      getData(); // Assuming these functions are defined elsewhere in your code
    } catch (error) {
      console.error(error);
      showAlert("Failed to update business location", "error");
    }
  }

  // Editing Ends Here

  // Delete

  async function handleDelete(id) {
    await employeeHRApis.deleteById(id);
    getData();
    showAlert("Deleted successfully", "warning");
  }

  // end delete
  const Trainee = "Trainee";
  const Junior = "Junior";
  const Senior = "Senior";
  const TeamLead = "Team Lead";
  const ProjectManager = "Project Manager";

  // Pagination handlers
  const handleChangePage = (newPage) => {
    console.log("Page changed to:", newPage);
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (numberOfRows) => {
    console.log("Rows per page changed to:", numberOfRows);
    setLimit(numberOfRows);
    setPage(0); // Reset to first page when changing page size
  };

  // Alternative pagination handlers for different MUI-Datatables versions
  const onTableChange = (action, tableState) => {
    console.log("Table change action:", action, "Table state:", tableState);
    switch (action) {
      case "changePage":
        console.log("Changing page to:", tableState.page);
        setPage(tableState.page);
        break;
      case "changeRowsPerPage":
        console.log("Changing rows per page to:", tableState.rowsPerPage);
        setLimit(tableState.rowsPerPage);
        setPage(0);
        break;
      default:
        break;
    }
  };

  const options = {
    selectableRows: "none",
    selectToolbarPlacement: "none",
    responsive: "standard",
    elevation: 0,
    rowsPerPage: limit,
    rowsPerPageOptions: [5, 10, 25, 100],
    serverSide: true,
    count: totalCount,
    page: page,
    onTableChange: onTableChange,
    onChangePage: handleChangePage,
    onChangeRowsPerPage: handleChangeRowsPerPage,
    tableBody: {
      style: {
        maxHeight: "500px",
        overflowY: "scroll",
        marginLeft: "5PX",
      },
    },
    tableHead: {
      style: {
        backgroundColor: "#f2f2f2",
        color: "black",
      },
    },
    rows: {
      style: {
        marginLeft: "5px",
        textAlign: "center",
      },
      selectableRowsOnClick: true,
    },
  };

  const getTheme = () =>
    createTheme({
      palette: {
        mode: "light",
        primary: {
          main: "#2196f3",
        },
        secondary: {
          main: "#03a9f4",
        },
      },
      typography: {
        fontFamily: ["Roboto", "Helvetica", "Arial", "Sans-serif"].join(","),
      },
      components: {
        MuiButton: {
          styleOverrides: {
            root: {
              textTransform: "none",
            },
          },
        },
      },
      tableBody: {
        style: {
          // maxWidth: "1000px",
          maxHeight: "500px",
          overflowY: "scroll",
        },
      },
      tableHead: {
        style: {
          backgroundColor: "#f2f2f2",
          color: "black",
        },
      },
      rows: {
        style: {
          "&:hover": {
            backgroundColor: "#f2f2f2",
          },
        },
      },
    });

  // Table Ends Here

  // Define reusable input styling to match RecJobs style
  const inputProps = {
    sx: {
      bgcolor: "#f9f9f9",
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "#e0e0e0",
        },
        "&:hover fieldset": {
          borderColor: "#bdbdbd",
        },
      },
      "& .MuiSelect-select": {
        color: "#424242", // For dropdown selects
      },
      "& .MuiInputBase-input": {
        color: "#424242", // For text and date inputs
      },
    },
  };

  const checkboxStyle = {
    color: "#9e9e9e",
    "&.Mui-checked": {
      color: "#4285F4",
    },
  };

  return (
    <>
      <StatusAlert
        open={alertOpen}
        setOpen={setAlertOpen}
        message={alertMessage}
        severity={alertSeverity}
      />
      <EmployeeHeader />
      <Box>
        <Dialog
          fullWidth
          maxWidth="lg"
          open={update}
          onClose={handleUpdateClose}
          TransitionComponent={Transition}
          PaperProps={{
            style: {
              position: "absolute",
              top: 0,
              right: 0,
              width: "85%",
              height: "100%",
              bgcolor: "#f5f5f5",
              boxShadow: 24,
              margin: "auto",
              overflowX: "hidden",
              zIndex: 1200,
            },
          }}
        >
          <AppBar sx={{ position: "relative", bgcolor: "#1d82f5" }}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleUpdateClose}
                aria-label="close"
              >
                <CloseIcon fontSize="large" />
              </IconButton>
              <Typography
                sx={{ ml: 2, flex: 1, fontSize: "18px" }}
                component="div"
              >
                Update Employee
              </Typography>
            </Toolbar>
          </AppBar>
          <Box sx={{ background: "#f5f5f5", p: 4, overflowY: "auto" }}>
            <Card
              sx={{
                p: 2,
                bgcolor: "#ffffff",
                boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.08)",
              }}
            >
              <CardContent>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Employee ID <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="e.g.ID-1"
                      size="small"
                      onChange={(e) => setEmpid(e.target.value)}
                      InputProps={inputProps}
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Name <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="e.g.Name"
                      size="small"
                      onChange={(e) => setName(e.target.value)}
                      InputProps={inputProps}
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Profile Picture
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <label
                        htmlFor="file-upload"
                        style={{
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "100%",
                          padding: "8px",
                          backgroundColor: "#f9f9f9",
                          border: "1px solid #e0e0e0",
                          borderRadius: "4px",
                          color: "#424242",
                        }}
                      >
                        Choose a File
                      </label>
                      <input
                        onChange={handleFileChangeProfile}
                        type="file"
                        id="file-upload"
                        style={{ display: "none" }}
                      />
                    </Box>
                    {uploadFile && (
                      <Typography
                        variant="caption"
                        sx={{ color: "#4285F4", mt: 1 }}
                      >
                        {uploadFile.name}
                      </Typography>
                    )}
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Personal Email <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="eg@example.com"
                      type="email"
                      size="small"
                      onChange={(e) => setEmail(e.target.value)}
                      InputProps={inputProps}
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Reporting To <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="abc"
                      type="text"
                      size="small"
                      onChange={(e) => setReportingTo(e.target.value)}
                      InputProps={inputProps}
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Password <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="Password"
                      type="password"
                      size="small"
                      onChange={(e) => setPassword(e.target.value)}
                      InputProps={inputProps}
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Designation <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <Box display="flex" alignItems="center">
                      <TextField
                        select
                        fullWidth
                        defaultValue="--"
                        size="small"
                        value={selectedDesignation}
                        onChange={(e) => setSelectedDesignation(e.target.value)}
                        InputProps={inputProps}
                      >
                        <MenuItem disabled value="--">
                          --
                        </MenuItem>
                        {designations &&
                          designations.map((item) => (
                            <MenuItem key={item.id} value={item.designation}>
                              {item.designation}
                            </MenuItem>
                          ))}
                      </TextField>
                      <Button
                        onClick={handleAddClickDesig}
                        sx={{
                          ml: 1,
                          border: "1px solid #e0e0e0",
                          color: "#424242",
                          "&:hover": {
                            bgcolor: "rgba(0, 0, 0, 0.04)",
                          },
                        }}
                      >
                        Add
                      </Button>
                    </Box>
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Department <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <Box display="flex" alignItems="center">
                      <TextField
                        select
                        fullWidth
                        defaultValue="--"
                        size="small"
                        value={selectedDepartment}
                        onChange={(e) => setSelectedDepartment(e.target.value)}
                        InputProps={inputProps}
                      >
                        <MenuItem disabled value="--">
                          --
                        </MenuItem>
                        {departments &&
                          departments.map((department) => (
                            <MenuItem
                              key={department.id}
                              value={department.department}
                            >
                              {department.department}
                            </MenuItem>
                          ))}
                      </TextField>
                      <Button
                        onClick={handleAddClick}
                        sx={{
                          ml: 1,
                          border: "1px solid #e0e0e0",
                          color: "#424242",
                          "&:hover": {
                            bgcolor: "rgba(0, 0, 0, 0.04)",
                          },
                        }}
                      >
                        Add
                      </Button>
                    </Box>
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Mobile No <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="e.g.+91 12345689"
                      size="small"
                      onChange={(e) => setMobile(e.target.value)}
                      InputProps={inputProps}
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Country <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="e.g.India"
                      size="small"
                      onChange={(e) => setCountry(e.target.value)}
                      InputProps={inputProps}
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Language <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="e.g.hindi, english"
                      size="small"
                      onChange={(e) => setLanguage(e.target.value)}
                      InputProps={inputProps}
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      User Role <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="e.g.abc"
                      size="small"
                      onChange={(e) => setUserRole(e.target.value)}
                      InputProps={inputProps}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Address <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="e.g.No:2468,Street, Nagar, City"
                      size="small"
                      onChange={(e) => setAddress(e.target.value)}
                      InputProps={inputProps}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      About
                    </Typography>
                    <TextField
                      multiline
                      rows={4}
                      fullWidth
                      placeholder="Type here..."
                      onChange={(e) => setAbout(e.target.value)}
                      InputProps={{
                        ...inputProps,
                        sx: {
                          ...inputProps.sx,
                          "& fieldset": {
                            border: "1px solid #e0e0e0",
                            borderRadius: "4px",
                          },
                          bgcolor: "#f9f9f9",
                        },
                      }}
                    />
                  </Grid>
                </Grid>

                <Box display="flex" gap={2} mt={3}>
                  <Button
                    onClick={UpdateData}
                    variant="contained"
                    sx={{
                      bgcolor: "#4285F4",
                      color: "white",
                      "&:hover": { bgcolor: "#3367D6" },
                      fontWeight: 500,
                      textTransform: "none",
                      padding: "8px 16px",
                    }}
                  >
                    Update
                  </Button>
                  <Button
                    onClick={handleUpdateClose}
                    variant="outlined"
                    sx={{
                      borderColor: "#bdbdbd",
                      color: "#424242",
                      "&:hover": {
                        borderColor: "#9e9e9e",
                        bgcolor: "rgba(0, 0, 0, 0.04)",
                      },
                      textTransform: "none",
                      padding: "8px 16px",
                    }}
                  >
                    Cancel
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Box>
        </Dialog>
      </Box>

      <List
        style={{
          background: "none",
          padding: 5,
        }}
      >
        <React.Fragment>
          {userPermissions?.employees_add !== 0 && (
            <Stack
              direction="row"
              spacing={2}
              sx={{ marginBottom: "5px", marginTop: "10px" }}
            >
              <Box
                onClick={handleClickOpen}
                sx={{
                  backgroundColor: "#4285F4",
                  "&:hover": { backgroundColor: "#3367D6" },
                  textAlign: "center",
                  padding: "10px",
                  marginLeft: "10px",
                  height: "40px",
                  width: "140px",
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "center",
                  borderRadius: "4px",
                  fontSize: "15px",
                  fontFamily: "sans-serif",
                  cursor: "pointer",
                  marginTop: "20px",
                }}
              >
                <AddIcon />
                Add Employee
              </Box>
            </Stack>
          )}
          <Dialog
            fullWidth
            maxWidth="lg"
            open={open}
            onClose={handleClose}
            TransitionComponent={Transition}
            PaperProps={{
              style: {
                position: "absolute",
                top: 0,
                right: 0,
                width: "calc(100% - 260px)", // Adjusted width to account for sidebar
                height: "100%",
                backgroundColor: "#f5f5f5",
                margin: 0,
                maxHeight: "100%",
                borderRadius: 0,
                overflowX: "hidden",
                zIndex: 1200,
              },
            }}
          >
            <AppBar
              sx={{
                position: "relative",
                bgcolor: "#ffffff",
                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
              }}
            >
              <Toolbar>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={handleClose}
                  aria-label="close"
                  sx={{ color: "#212121" }}
                >
                  <CloseIcon fontSize="large" />
                </IconButton>
                <Typography
                  sx={{ ml: 2, flex: 1, fontSize: "18px", color: "#212121" }}
                  component="div"
                >
                  Add New Employee
                </Typography>
              </Toolbar>
            </AppBar>
            <Box sx={{ background: "#f5f5f5", p: 4, overflowY: "auto" }}>
              <Card
                sx={{
                  p: 2,
                  bgcolor: "#ffffff",
                  boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.08)",
                }}
              >
                <CardContent>
                  <Typography variant="h6" sx={{ color: "#212121", mb: 3 }}>
                    Employee Information
                  </Typography>
                  <Divider sx={{ mb: 3 }} />

                  <Grid container spacing={3}>
                    {/* First row */}
                    <Grid item xs={12} md={3}>
                      <Typography
                        variant="body1"
                        mb={1}
                        sx={{ color: "#212121" }}
                      >
                        Employee ID <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <TextField
                        fullWidth
                        placeholder="e.g. EMP-001"
                        size="small"
                        onChange={(e) => setEmpid(e.target.value)}
                        InputProps={inputProps}
                      />
                    </Grid>

                    <Grid item xs={12} md={3}>
                      <Typography
                        variant="body1"
                        mb={1}
                        sx={{ color: "#212121" }}
                      >
                        Name <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <TextField
                        fullWidth
                        placeholder="Enter full name"
                        size="small"
                        onChange={(e) => setName(e.target.value)}
                        InputProps={inputProps}
                      />
                    </Grid>

                    <Grid item xs={12} md={3}>
                      <Typography
                        variant="body1"
                        mb={1}
                        sx={{ color: "#212121" }}
                      >
                        Personal Email <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <TextField
                        fullWidth
                        placeholder="email@example.com"
                        type="email"
                        size="small"
                        onChange={(e) => setEmail(e.target.value)}
                        InputProps={inputProps}
                      />
                    </Grid>

                    <Grid item xs={12} md={3}>
                      <Typography
                        variant="body1"
                        mb={1}
                        sx={{ color: "#212121" }}
                      >
                        Password <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <TextField
                        fullWidth
                        placeholder="Enter password"
                        type="password"
                        size="small"
                        onChange={(e) => setPassword(e.target.value)}
                        InputProps={inputProps}
                      />
                    </Grid>

                    {/* Second row */}
                    <Grid item xs={12} md={3}>
                      <Typography
                        variant="body1"
                        mb={1}
                        sx={{ color: "#212121" }}
                      >
                        Department <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <Box display="flex" alignItems="center">
                        <TextField
                          select
                          fullWidth
                          defaultValue=""
                          size="small"
                          value={selectedDepartment}
                          onChange={(e) =>
                            setSelectedDepartment(e.target.value)
                          }
                          InputProps={inputProps}
                        >
                          <MenuItem value="">
                            <em>Select department</em>
                          </MenuItem>
                          {departments &&
                            departments.map((department) => (
                              <MenuItem
                                key={department.id}
                                value={department.department}
                              >
                                {department.department}
                              </MenuItem>
                            ))}
                        </TextField>
                        <Button
                          onClick={handleAddClick}
                          sx={{
                            ml: 1,
                            border: "1px solid #e0e0e0",
                            color: "#424242",
                            "&:hover": {
                              bgcolor: "rgba(0, 0, 0, 0.04)",
                            },
                          }}
                        >
                          Add
                        </Button>
                      </Box>
                    </Grid>

                    <Grid item xs={12} md={3}>
                      <Typography
                        variant="body1"
                        mb={1}
                        sx={{ color: "#212121" }}
                      >
                        Designation <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <Box display="flex" alignItems="center">
                        <TextField
                          select
                          fullWidth
                          defaultValue=""
                          size="small"
                          value={selectedDesignation}
                          onChange={(e) =>
                            setSelectedDesignation(e.target.value)
                          }
                          InputProps={inputProps}
                        >
                          <MenuItem value="">
                            <em>Select designation</em>
                          </MenuItem>
                          {designations &&
                            designations.map((item) => (
                              <MenuItem key={item.id} value={item.designation}>
                                {item.designation}
                              </MenuItem>
                            ))}
                        </TextField>
                        <Button
                          onClick={handleAddClickDesig}
                          sx={{
                            ml: 1,
                            border: "1px solid #e0e0e0",
                            color: "#424242",
                            "&:hover": {
                              bgcolor: "rgba(0, 0, 0, 0.04)",
                            },
                          }}
                        >
                          Add
                        </Button>
                      </Box>
                    </Grid>

                    <Grid item xs={12} md={3}>
                      <Typography
                        variant="body1"
                        mb={1}
                        sx={{ color: "#212121" }}
                      >
                        Reporting To <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <TextField
                        select
                        fullWidth
                        size="small"
                        onChange={(e) => setReportingTo(e.target.value)}
                        InputProps={inputProps}
                        defaultValue=""
                      >
                        <MenuItem value="">
                          <em>Select manager</em>
                        </MenuItem>
                        {Array.isArray(apiEmployees)
                          ? apiEmployees.map((employee) => (
                              <MenuItem key={employee.id} value={employee.name}>
                                {employee.name}
                              </MenuItem>
                            ))
                          : null}
                      </TextField>
                    </Grid>

                    <Grid item xs={12} md={3}>
                      <Typography
                        variant="body1"
                        mb={1}
                        sx={{ color: "#212121" }}
                      >
                        Profile Picture
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        <label
                          htmlFor="file-upload"
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "100%",
                            padding: "8px",
                            backgroundColor: "#f9f9f9",
                            border: "1px solid #e0e0e0",
                            borderRadius: "4px",
                            color: "#424242",
                          }}
                        >
                          Choose File
                        </label>
                        <input
                          onChange={handleFileChangeProfile}
                          type="file"
                          id="file-upload"
                          style={{ display: "none" }}
                        />
                      </Box>
                      {uploadFile && (
                        <Typography
                          variant="caption"
                          sx={{ color: "#4285F4", mt: 1, display: "block" }}
                        >
                          {uploadFile.name}
                        </Typography>
                      )}
                    </Grid>

                    {/* Third row */}
                    <Grid item xs={12} md={3}>
                      <Typography
                        variant="body1"
                        mb={1}
                        sx={{ color: "#212121" }}
                      >
                        Mobile Number <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <TextField
                        fullWidth
                        placeholder="+91 1234567890"
                        size="small"
                        onChange={(e) => setMobile(e.target.value)}
                        InputProps={inputProps}
                      />
                    </Grid>

                    <Grid item xs={12} md={3}>
                      <Typography
                        variant="body1"
                        mb={1}
                        sx={{ color: "#212121" }}
                      >
                        Country <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <TextField
                        fullWidth
                        placeholder="e.g. India"
                        size="small"
                        onChange={(e) => setCountry(e.target.value)}
                        InputProps={inputProps}
                      />
                    </Grid>

                    <Grid item xs={12} md={3}>
                      <Typography
                        variant="body1"
                        mb={1}
                        sx={{ color: "#212121" }}
                      >
                        Language <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <TextField
                        fullWidth
                        placeholder="e.g. Hindi, English"
                        size="small"
                        onChange={(e) => setLanguage(e.target.value)}
                        InputProps={inputProps}
                      />
                    </Grid>

                    <Grid item xs={12} md={3}>
                      <Typography
                        variant="body1"
                        mb={1}
                        sx={{ color: "#212121" }}
                      >
                        User Role <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <TextField
                        select
                        fullWidth
                        size="small"
                        onChange={(e) => setUserRole(e.target.value)}
                        InputProps={inputProps}
                        defaultValue=""
                      >
                        <MenuItem value="">
                          <em>Select role</em>
                        </MenuItem>
                        <MenuItem value="Admin">Admin</MenuItem>
                        <MenuItem value="HR">HR</MenuItem>
                        <MenuItem value="Employee">Employee</MenuItem>
                        <MenuItem value="Manager">Manager</MenuItem>
                      </TextField>
                    </Grid>

                    {/* Fourth row */}
                    <Grid item xs={12}>
                      <Typography
                        variant="body1"
                        mb={1}
                        sx={{ color: "#212121" }}
                      >
                        Address <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <TextField
                        fullWidth
                        placeholder="Enter full address"
                        size="small"
                        onChange={(e) => setAddress(e.target.value)}
                        InputProps={inputProps}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <Typography
                        variant="body1"
                        mb={1}
                        sx={{ color: "#212121" }}
                      >
                        About
                      </Typography>
                      <TextField
                        multiline
                        rows={4}
                        fullWidth
                        placeholder="Enter details about the employee..."
                        onChange={(e) => setAbout(e.target.value)}
                        InputProps={inputProps}
                      />
                    </Grid>
                  </Grid>

                  <Box display="flex" gap={2} mt={3}>
                    <Button
                      onClick={SaveDate}
                      variant="contained"
                      sx={{
                        bgcolor: "#4285F4",
                        color: "white",
                        "&:hover": { bgcolor: "#3367D6" },
                        fontWeight: 500,
                        textTransform: "none",
                        padding: "8px 16px",
                      }}
                    >
                      Save
                    </Button>
                    <Button
                      onClick={handleClose}
                      variant="outlined"
                      sx={{
                        borderColor: "#bdbdbd",
                        color: "#424242",
                        "&:hover": {
                          borderColor: "#9e9e9e",
                          bgcolor: "rgba(0, 0, 0, 0.04)",
                        },
                        textTransform: "none",
                        padding: "8px 16px",
                      }}
                    >
                      Cancel
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Box>
          </Dialog>
        </React.Fragment>

        {/* Department & Designation Dialog modals - keep these unchanged */}
        <Dialog
          fullWidth
          maxWidth="md"
          open={openDialog}
          onClose={handleDialogClose}
          TransitionComponent={Transition}
          PaperProps={{
            style: {
              position: "absolute",
              background: "#141b2d",
              top: "0",
              backgroundColor: "white",
              maxHeight: "95%",
              margin: "auto",
              overflowX: "hidden",
              zIndex: 1200,
            },
          }}
        >
          <Box sx={{ background: "#fff", color: "#000" }}>
            <DialogTitle>
              <span
                style={{
                  background: "#4285F4",
                  color: "#fff",
                  padding: "15px",
                  borderRadius: "5px",
                }}
              >
                Add New Department
              </span>
            </DialogTitle>
            <Grid
              container
              spacing={2}
              sx={{
                padding: { xs: "10px", sm: "20px" },
              }}
            >
              <Grid item xs={12} sm={6} md={6}>
                <Stack direction="column" spacing={2}>
                  <Typography>Name</Typography>
                  <TextField
                    autoFocus
                    margin="dense"
                    placeholder="Department Name"
                    type="text"
                    fullWidth
                    value={newDepartment}
                    onChange={(e) => setNewDepartment(e.target.value)}
                    InputProps={inputProps}
                  />
                </Stack>
              </Grid>

              <Grid item xs={11.5} sx={{ textAlign: "start" }}>
                <DialogActions>
                  <Button
                    onClick={handleDialogClose}
                    variant="outlined"
                    sx={{
                      borderColor: "#bdbdbd",
                      color: "#424242",
                      "&:hover": {
                        borderColor: "#9e9e9e",
                        bgcolor: "rgba(0, 0, 0, 0.04)",
                      },
                      textTransform: "none",
                      padding: "8px 16px",
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={AddDepartment}
                    variant="contained"
                    sx={{
                      bgcolor: "#4285F4",
                      color: "white",
                      "&:hover": { bgcolor: "#3367D6" },
                      fontWeight: 500,
                      textTransform: "none",
                      padding: "8px 16px",
                    }}
                  >
                    Add
                  </Button>
                </DialogActions>
              </Grid>
            </Grid>
          </Box>
        </Dialog>

        <Dialog
          fullWidth
          maxWidth="md"
          open={openDialogDesig}
          onClose={handleDialogCloseDesig}
          TransitionComponent={Transition}
          PaperProps={{
            style: {
              position: "absolute",
              background: "#141b2d",
              top: "0",
              backgroundColor: "white",
              maxHeight: "95%",
              margin: "auto",
              overflowX: "hidden",
              zIndex: 1200,
            },
          }}
        >
          <Box sx={{ background: "#fff", color: "#000" }}>
            <DialogTitle>
              <span
                style={{
                  background: "#4285F4",
                  color: "#fff",
                  padding: "15px",
                  borderRadius: "5px",
                }}
              >
                Add New Designation
              </span>
            </DialogTitle>
            <Grid
              container
              spacing={2}
              sx={{
                marginTop: "10px",
                padding: { xs: "10px", sm: "20px" },
              }}
            >
              <Grid item xs={12} sm={6} md={5.5}>
                <Stack direction="column" spacing={2}>
                  <Typography>Name</Typography>
                  <TextField
                    autoFocus
                    margin="dense"
                    placeholder="Designation Name"
                    type="text"
                    fullWidth
                    value={newDesignation}
                    onChange={(e) => setNewDesignation(e.target.value)}
                    InputProps={inputProps}
                  />
                </Stack>
              </Grid>

              <Grid item xs={11.5} sx={{ textAlign: "start" }}>
                <DialogActions>
                  <Button
                    onClick={handleDialogCloseDesig}
                    variant="outlined"
                    sx={{
                      borderColor: "#bdbdbd",
                      color: "#424242",
                      "&:hover": {
                        borderColor: "#9e9e9e",
                        bgcolor: "rgba(0, 0, 0, 0.04)",
                      },
                      textTransform: "none",
                      padding: "8px 16px",
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={AddDesignation}
                    variant="contained"
                    sx={{
                      bgcolor: "#4285F4",
                      color: "white",
                      "&:hover": { bgcolor: "#3367D6" },
                      fontWeight: 500,
                      textTransform: "none",
                      padding: "8px 16px",
                    }}
                  >
                    Add
                  </Button>
                </DialogActions>
              </Grid>
            </Grid>
          </Box>
        </Dialog>

        <Divider />
        <ListItemText style={{ background: "white", margin: 0 }}>
          <ThemeProvider theme={getTheme()}>
            <Box
              sx={{
                maxWidth: "100%",
              }}
            >
              <MUIDataTable
                title={
                  <span
                    style={{
                      fontWeight: 700,
                      fontSize: "1.5rem",
                      color: "#333",
                    }}
                  >
                    Employee Lists
                  </span>
                }
                data={employeeData}
                columns={columns}
                options={options}
              />
            </Box>
          </ThemeProvider>
        </ListItemText>
      </List>
    </>
  );
}

export default Employee;
